import {
  ItemExpireContext as MessageExpireContext,
  MessageMedia,
  MessageMetaRoot,
  MessageReadStatus,
} from '@halo/ui-chat-react';
import {
  isSessionCategory,
  SessionCategoryPrefix,
  type Msg,
  type Session,
} from '@halo/chat-sdk-react';
import { Center } from '@chakra-ui/react';
import { useIsMyMsg } from '@/scripts/hooks';
import { MsgAvatar, MsgBody, MsgExpireAnimate, MsgHeader, MsgItem } from '../../msg-parts';

export interface MsgMediaCardProps {
  session: Session;
  message: Msg;
  children?: ReactNode;
}

export const MsgMediaCard = memo(function MsgMediaCard({
  message,
  session,
  children,
}: MsgMediaCardProps) {
  const isMe = useIsMyMsg(message);

  const isGroup = useMemo(() => {
    return isSessionCategory(session.chat_id, SessionCategoryPrefix.Group);
  }, [session]);

  return (
    <MsgItem message={message}>
      <MessageExpireContext message={message}>
        <MsgAvatar message={message} session={session} />
        <MsgBody message={message}>
          <MsgHeader message={message} session={session} />
          <MsgExpireAnimate session={session} message={message}>
            <MessageMedia isMe={isMe}>
              {children}
              {!isGroup && (
                <MessageMetaRoot mt="0">
                  <Center marginLeft="auto" gap="1.5">
                    <MessageReadStatus message={message} session={session} />
                  </Center>
                </MessageMetaRoot>
              )}
            </MessageMedia>
          </MsgExpireAnimate>
        </MsgBody>
      </MessageExpireContext>
    </MsgItem>
  );
});
